import { RitzAPI, } from '@moderepo/mode-internal-apis';
import { searchParamsToString, } from '@moderepo/mode-data-state-base';
/**
 * The types of action that can be dispatched to update this sub state.
 */
export var ProjectDevicesActionType;
(function (ProjectDevicesActionType) {
    ProjectDevicesActionType["SET_PROJECT_DEVICES"] = "set project devices";
    ProjectDevicesActionType["SET_PROJECT_DEVICE"] = "set project device";
    ProjectDevicesActionType["CLEAR_PROJECT_DEVICES"] = "clear project devices";
})(ProjectDevicesActionType || (ProjectDevicesActionType = {}));
/**
 * Create an action to set a list of devices for a project
 */
export const setProjectDevices = (projectId, devicesDataSet, searchParams) => {
    return {
        type: ProjectDevicesActionType.SET_PROJECT_DEVICES,
        projectId,
        devicesDataSet,
        searchParams,
    };
};
/**
 * Create an interface to set 1 device
 * @param device
 */
export const setProjectDevice = (device) => {
    return {
        type: ProjectDevicesActionType.SET_PROJECT_DEVICE,
        device,
    };
};
export const clearProjectDevices = (projectId) => {
    return {
        type: ProjectDevicesActionType.CLEAR_PROJECT_DEVICES,
        projectId,
    };
};
/**
 * Get all the devices of a project for the specified filters.
 * IMPORTANT NOTE: This API is for getting all devices for a project, not for a specific home. The result
 * will includes devices that are not linked to any home. To get only devices for a specific home, call
 * the getHomeDevices instead.
 *
 * @param projectId - The id of the project the devices belonged to
 * @param searchText - Filter the result by this search text. If not provided, return all
 * @param deviceClass - Filter the result by this device class
 * @param pageNumber - The page number. Use for paging.
 * @param pageSize - Return only 'limit' number of result. If not provided, return all
 */
export const fetchProjectDevices = (projectId, searchText, deviceClass, pageNumber, pageSize) => {
    return async (dataDispatch) => {
        const devices = await RitzAPI.getInstance().getProjectDevices(projectId, searchText, deviceClass, pageNumber !== undefined && pageSize !== undefined ? pageNumber * pageSize : undefined, pageSize);
        await dataDispatch(setProjectDevices(projectId, devices, searchParamsToString({
            searchText, deviceClass, pageNumber, pageSize,
        })));
    };
};
/**
 * Get the device data by the specified deviceId
 * @param projectId - The id of the project the devices belonged to
 * @param deviceId - The id of the device which we want to get
 */
export const fetchProjectDeviceById = (projectId, deviceId) => {
    return async (dataDispatch) => {
        const device = await RitzAPI.getInstance().getProjectDeviceById(projectId, deviceId);
        await dataDispatch(setProjectDevice(device));
    };
};
/**
 * Delete a device from a project.
 * @param deviceId - The id of the device we want to delete
 */
export const deleteProjectDevice = (projectId, deviceId) => {
    return async (dataDispatch) => {
        await RitzAPI.getInstance().deleteProjectDevice(deviceId);
        await dataDispatch(clearProjectDevices(projectId));
    };
};
/**
 * Update a project device.
 * @param projectId - The id of the project the devices belonged to
 */
export const createProjectDevice = (projectId, deviceClass, name, tag) => {
    return async (dataDispatch) => {
        await RitzAPI.getInstance().createProjectDevice(projectId, deviceClass, name, tag);
        await dataDispatch(clearProjectDevices(projectId));
    };
};
/**
 * Update a project device.
 * @param projectId - The id of the project the devices belonged to
 * @param deviceId - The id of the device which we want to get
 * @param updatedData - The object including fields/values you want to update. The fields that can be updated are
 *                      name, tag, and claimCode
 */
export const updateProjectDevice = (projectId, deviceId, updatedData) => {
    return async (dataDispatch) => {
        await RitzAPI.getInstance().updateProjectDevice(projectId, deviceId, updatedData);
        await dataDispatch(fetchProjectDeviceById(projectId, deviceId));
    };
};
